import { MEMBER_ACTIONS_PERMISSIONS } from '@bo-constants/permissions';
import { createSelector } from '@reduxjs/toolkit';
import { selectUserRoles } from '@bo-services/authenticationSlice';

const {
  MEMBER_ACTIONS_MENU,
  MEMBER_CHANGE_LOG,
  MEMBER_CREATE_ADJUSTMENT,
  MEMBER_DEACTIVATE_USER,
  MEMBER_EDIT_ACCOUNT_INFORMATION,
  MEMBER_ENROLL_KINDBRIDGE,
  MEMBER_MANAGE_GROUPS,
  MEMBER_MANAGE_TIN_COLLECTION,
  MEMBER_MANAGE_VIP_STATUS,
  MEMBER_MANUALLY_PASS_USER,
  MEMBER_REFUND_ENTRY,
  MEMBER_RESET_PASSWORD,
  MEMBER_VIEW_RULESET
} = MEMBER_ACTIONS_PERMISSIONS;

export const selectMemberActionsAccessPermissions = createSelector(
  [selectUserRoles],
  (roles) => {
    const hasAccessMemberActionsMenu = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_ACTIONS_MENU
      )
    );

    const hasAccessMemberChangeLog = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_CHANGE_LOG
      )
    );

    const hasAccessMemberCreateAdjustment = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_CREATE_ADJUSTMENT
      )
    );

    const hasAccessMemberEditAccountInfo = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_EDIT_ACCOUNT_INFORMATION
      )
    );

    const hasAccessMemberEnrollKindbridge = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_ENROLL_KINDBRIDGE
      )
    );

    const hasAccessMemberDeactivateUser = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_DEACTIVATE_USER
      )
    );

    const hasAccessMemberManageGroups = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_MANAGE_GROUPS
      )
    );

    const hasAccessMemberRulesets = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_VIEW_RULESET
      )
    );

    const hasAccessMemberManageTinCollection = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_MANAGE_TIN_COLLECTION
      )
    );

    const hasAccessMemberManageVipStatus = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_MANAGE_VIP_STATUS
      )
    );

    const hasAccessMemberManuallyPassUser = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_MANUALLY_PASS_USER
      )
    );

    const hasAccessMemberRefundEntry = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_REFUND_ENTRY
      )
    );

    const hasAccessMemberResetPassword = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_RESET_PASSWORD
      )
    );

    return {
      hasAccessMemberDeactivateUser,
      hasAccessMemberActionsMenu,
      hasAccessMemberChangeLog,
      hasAccessMemberCreateAdjustment,
      hasAccessMemberEditAccountInfo,
      hasAccessMemberEnrollKindbridge,
      hasAccessMemberManageGroups,
      hasAccessMemberRulesets,
      hasAccessMemberManageTinCollection,
      hasAccessMemberManageVipStatus,
      hasAccessMemberManuallyPassUser,
      hasAccessMemberRefundEntry,
      hasAccessMemberResetPassword
    };
  }
);
